/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input, OnInit } from '@angular/core';
import { GeneratedReportConditionalSection, ReportCompetencyLevelWrapper } from '../../../../../../shared/models';

@Component({
  selector: 'ptl-diagnostics-report-conditional-section-view',
  templateUrl: './diagnostics-report-conditional-section-view.component.html',
  styleUrls: ['./diagnostics-report-conditional-section-view.component.scss'],
})
export class DiagnosticsReportConditionalSectionViewComponent implements OnInit {
  @Input() isPercentageEnabled = false;

  @Input() section: GeneratedReportConditionalSection;

  @Input() isFirst: boolean;

  @Input() is360: boolean;

  @Input() levels: ReportCompetencyLevelWrapper[] = [];

  radius = 54;
  circumference = 2 * Math.PI * this.radius;
  progressColor = '';
  percentageValue: number;
  scored: number;

  ngOnInit() {
    this.progressColor = this.section.chartColor;

    this.percentageValue = Math.floor((this.section.learningGoalWrapper.scored * 100) / this.section.learningGoalWrapper.maxScore);

    if (this.section.learningGoalWrapper.scored) {
      this.scored = Math.floor(this.section.learningGoalWrapper.scored);
    }
  }

  get scoredRatio() {
    return this.section.learningGoalWrapper.scored / this.section.learningGoalWrapper.maxScore;
  }

  get scoredPercentage() {
    return (this.section.learningGoalWrapper.scored * 100) / this.section.learningGoalWrapper.maxScore;
  }

  get dashoffset() {
    return this.circumference * (1 - this.scoredRatio);
  }

  get svgStroke() {
    return this.progressColor ? this.progressColor : `url(${window.location.pathname}#gradient)`;
  }
}
